import { Controller } from '@hotwired/stimulus';

/**
 * Removes a cancel-flow confirmation banner after a short delay. Alerts do not
 * use it, so an error stays on screen until the customer acts.
 */
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } };

  /**
   * Schedules the banner's removal.
   */
  connect() {
    this.timeout = setTimeout(() => this.element.remove(), this.delayValue);
  }

  /**
   * Cancels the pending removal when the banner leaves the page first.
   */
  disconnect() {
    clearTimeout(this.timeout);
  }
}
